<app-selector label="Jumble" [data]="jumbleCoreService.jumblesList$| async" displayKey="name"
    [formControl]="ctrl" hintStyle="margin-left: -14px; margin-top: -5px" (refreshEvent)="refresh()" [loading]="jumbleCoreService.loading" [hint]="hint">
</app-selector>
